import { render, staticRenderFns } from "./product-pdf.vue?vue&type=template&id=22f6ca84&"
import script from "./product-pdf.vue?vue&type=script&lang=js&"
export * from "./product-pdf.vue?vue&type=script&lang=js&"
import style0 from "./product-pdf.vue?vue&type=style&index=0&id=22f6ca84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports